import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";

const BroadcastCenter = React.lazy(() => import("./pages/BroadcastCenter"));
const StudioPage = React.lazy(() => import("./pages/StudioPage"));
const PostProductionPage = React.lazy(() => import("./pages/PostProductionPage"));
const MediaCenterPage = React.lazy(() => import("./pages/MediaCenterPage"));
const OthersPage = React.lazy(() => import("./pages/OthersPage"));

const App = () => (
  <Suspense fallback={null}>
    <Routes>
      <Route path="/" element={<BroadcastCenter />} />
      <Route path="/broadcastcenter" element={<BroadcastCenter />} />
      <Route path="/studio" element={<StudioPage />} />
      <Route path="/postproduction" element={<PostProductionPage />} />
      <Route path="/media-center" element={<MediaCenterPage />} />
      <Route path="/others" element={<OthersPage />} />
      <Route path="*" element={<BroadcastCenter />} />
    </Routes>
  </Suspense>
);

export default App;
